export const options = {
  /*builder: {
    basic: false,
    data: false,
    premium: false,
    customBasic: {
      title: 'Basic Components',
      default: true,
      weight: 0,
      components: {
        textfield: true,
        textarea: true,
        email: true
      }
    },
    advanced: {
      components: {
        email: true,
        url: true,
        tags: true,
        address: true,
        survey: true,
        currency: true,
        signature: true,
        day: true,
        phoneNumber: true,
        datetime: true
      }
    },
    layout: {
      title: 'Layout Components',
      weight: 0,
      components: {
        panel: true,
        table: true,
        tabs: true,
        well: true,
        columns: true,
        fieldset: true,
        content: true,
        htmlelement: true
      }
    }
  },*/
  theme: 'bootstrap5',
  language: 'hu',
  sanitizeConfig: {
    addTags: ['iframe'],
    addAttr: [
      'src',
      'style',
      'width',
      'height',
      'frameborder',
      'allow',
      'allowfullscreen',
      'loading',
      'referrerpolicy',
      'title'
    ]
  },
  i18n: {
    hu: {
      'Label': 'Címke',
      'Label Position': 'Címke pozíció',
      'Placeholder': 'Helykitöltő',
      'Description': 'Leírás',
      'Tooltip': 'Eszköztipp',
      'Prefix': 'Előtag',
      'Suffix': 'Utótag',
      'Widget': 'Widget',
      'Input Mask': 'Beviteli maszk',
      'Custom CSS Class': 'Egyedi CSS osztály',
      'Tab Index': 'Fül index',
      'Hidden': 'Elrejtett',
      'Hide Label': 'Címke elrejtése',
      'Show Word Counter': 'Szószámláló megjelenítése',
      'Show Character Counter': 'Karakter számláló megjelenítése',
      'Hide Input': 'Bevitel elrejtése',
      'Excellent': 'Kiváló',
      'Initial Focus': 'Kezdő fókusz',
      'Allow Spellcheck': 'Helyesírás-ellenőrzés engedélyezése',
      'Disabled': 'Letiltva',
      'Table View': 'Táblanézet',
      'Modal Edit': 'Modális szerkesztés',
      'Multiple Values': 'Több érték',
      'Persistent': 'Tartós',
      'Input Format': 'Beviteli formátum',
      'Protected': 'Védett',
      'Database Index': 'Adatbázis index',
      'Mixed (Allow upper and lower case)': 'Vegyes (nagy- és kisbetű engedélyezése)',
      'Uppercase': 'Nagybetűs',
      'Lowercase': 'Kisbetűs',
      'Encrypted (Enterprise Only)': 'Titkosított (csak vállalati)',
      'Default Value': 'Alapértelmezett érték',
      'Drag and Drop a form component': 'Húzzon ide egy elemet a kezdéshez',
      'Text Field': 'Szövegmező',
      'Email': 'E-mail',
      'Text Area': 'Szövegterület',
      'Panel': 'Panel',
      'Time': 'Idő',
      'Submit': 'Kérvény beküldése',
      'Basic Components': 'Alapvető komponensek',
      'Layout Components': 'Elrendezés komponensek',
      'Advanced': 'Haladó',
      'Component': 'Komponens',
      'Display': 'Megjelenítés',
      'Data': 'Adat',
      'Validation': 'Ellenőrzés',
      'API': 'API',
      'Conditional': 'Feltételes',
      'Logic': 'Logika',
      'Layout': 'Elrendezés',
      'Allow Multiple Masks': 'Több maszk engedélyezése',
      'Input Field': 'Beviteli mező',
      'Top': 'Felül',
      'Input Type': 'Beviteli típus',
      'Collapsible': 'Összecsukható',
      'Preview': 'Előnézet',
      'Text Case': 'Szöveg esete',
      'Redraw On': 'Újrarajzolás',
      'Clear Value When Hidden': 'Érték törlése elrejtéskor',
      'Custom Default Value': 'Egyedi alapértelmezett érték',
      'Calculated Value': 'Számított érték',
      'Calculate Value on server': 'Érték számítása a szerveren',
      'Allow Manual Override of Calculated Value': 'Számított érték kézi felülírásának engedélyezése',
      'Server': 'Szerver',
      'Client': 'Kliens',
      'None': 'Nincs',
      'Validate On': 'Ellenőrzés',
      'Required': 'Kötelező',
      'Unique': 'Egyedi',
      'Minimum Length': 'Minimális hossz',
      'Maximum Length': 'Maximális hossz',
      'Minimum Word Length': 'Minimális szószám',
      'Maximum Word Length': 'Maximális szószám',
      'Regular Expression Pattern': 'Szabályos kifejezés minta',
      'Error Label': 'Hibacímke',
      'Custom Error Message': 'Egyedi hibaüzenet',
      'Custom Validation': 'Egyedi érvényesítés',
      'JSONLogic Validation': 'JSONLogic érvényesítés',
      'Property Name': 'Tulajdonság neve',
      'Field Tags': 'Mezőcímkék',
      'Custom Properties': 'Egyedi tulajdonságok',
      'Add Another': 'Újabb hozzáadása',
      'Save': 'Mentés',
      'Cancel': 'Mégse',
      'Remove': 'Eltávolítás',
      'Rows': 'Sorok',
      'Title': 'Cím',
      'Theme': 'Téma',
      'Data Format': 'Adatformátum',
      'Advanced Logic': 'Haladó logika',
      'Advanced Conditions': 'Haladó feltételek',
      'Simple': 'Egyszerű',
      'HTML Attributes': 'HTML attribútumok',
      'PDF Overlay': 'PDF fedvény',
      'Number': 'Szám',
      'Password': 'Jelszó',
      'Checkbox': 'Jelölőnégyzet',
      'Select Boxes': 'Választó dobozok',
      'Select': 'Választó menü',
      'Radio': 'Rádiógombok',
      'Button': 'Gomb',
      'Basic': 'Alapvető elemek',
      'Page': 'Oldal',
      'Page 1': '1. Oldal',
      'Page 2': '2. Oldal',
      'Page 3': '3. Oldal',
      'Page 4': '4. Oldal',
      'Page 5': '5. Oldal',
      'Page 6': '6. Oldal',
      'Page 7': '7. Oldal',
      'Page 8': '8. Oldal',
      'Page 9': '9. Oldal',
      'Page 10': '10. Oldal',
      'Page 11': '11. Oldal',
      'Page 12': '12. Oldal',
      'Page 13': '13. Oldal',
      'Page 14': '14. Oldal',
      'Page 15': '15. Oldal',
      'Page 16': '16. Oldal',
      'Page 17': '17. Oldal',
      'Page 18': '18. Oldal',
      'Page 19': '19. Oldal',
      'Page 20': '20. Oldal',
      'Submit Form': 'Küldés',
      'Next': 'Következő',
      'Previous': 'Előző',
      'Submission Complete.':'Feldolgozás megkezdve!',
      'Submission Complete':'Feldolgozás megkezdve!',
    }
  }
};
